<template>
  <div class="slide-page" @touchmove="handleTouchMove">
    <NavBarM @jump="jump" ref="navbar"></NavBarM>
    <!-- 校招流程 -->
    <div class="slide-content" ref="content">
      <div>
        <img
          style="height: 15.97rem; width: auto"
          src="../../assets/img/app/app_FAQ-img.png"
          alt=""
        />
      </div>
    </div>
    <FooterM></FooterM>
  </div>
</template>

<script>
import BScroll from "@better-scroll/core";
import NestedScroll from "@better-scroll/nested-scroll";
import NavBarM from "../../components/NavBarM.vue";
import FooterM from "../../components/FooterM.vue";
BScroll.use(NestedScroll);
export default {
  components: {
    FooterM,
    NavBarM,
  },
  data() {
    return {
      bScroll: null,
    };
  },
  methods: {
    jump(index) {
      this.$emit("jump", index);
    },
    handleTouchMove() {
      this.$refs.navbar.hidden();
    },
  },
};
</script>

<style scoped>
img {
  width: 2rem;
}
/deep/ .el-collapse-item__arrow {
  display: none;
}
.slide-page {
  font-size: 11.2rem;
}
.slide-content > div {
  min-height: unset !important;
}
</style>
